export const PIX_MODAL_STAGES = {
  INITIAL: 'initial',
  COPY: 'copy_success',
  ERROR: 'error',
}
